<template>
  <el-tag :type="labelType">
    {{ title }}
  </el-tag>
</template>
<script lang="ts">
import { defineComponent, computed } from 'vue'

const TYPES: Record<number, string> = {
  2: 'warning',
  0: 'success',
  3: 'danger',
  6: 'success',
  7: 'danger',
  99: 'primary'
}

const TITLES: Record<number, string> = {
  0: 'Added',
  1: 'Withdrawn',
  2: 'Spends',
  3: 'Refund',
  4: 'Fee',
  5: 'Fee',
  6: 'Replenishment',
  7: 'Rejected',
  8: 'Fee',
  99: 'Pending'
}

export default defineComponent({
  name: 'TypeLabel',
  props: {
    type: {
      type: Number,
      required: true
    }
  },
  setup(props, context) {
    const labelType = computed(() => {
      return TYPES[props.type]
    })
    const title = computed(() => {
      return TITLES[props.type]
    })
    return { labelType, title }
  }
})
</script>
